Ext.define('SA.view.menu.SvgIconItem', {
    alias: 'widget.menu-svg-icon-item',
    extend: 'Ext.menu.Item',

    hrefTarget: '_blank',

    renderTpl: [
        '<a id="{id}-itemEl" class="x-menu-item-link" href="{href}" target="{hrefTarget}" hidefocus="true">',
            '<svg class="sa-menu-svg-icon-item-svg"><use href="#{icon}"></use></svg>',
            '<span id="{id}-textEl" class="x-menu-item-text" unselectable="on">{text}</span>',
        '</a>'
    ]
});
